// extracted by mini-css-extract-plugin
export default {"priceTotalContainer":"TotalToPay__priceTotalContainer___g1sNk","tabletAsMobileMode":"TotalToPay__tabletAsMobileMode___zzqHC","priceTotal":"TotalToPay__priceTotal___ZIhe2"};